import axios from "axios";
import moment from "moment";

export const GET_TRASLADOS_HISTORIAL = "GET_TRASLADOS_HISTORIAL";
export const GET_TRASLADOS_REFERENTES = "GET_TRASLADOS_REFERENTES";
export const GET_TRASLADOS_SITUACION_ACTUAL = "GET_TRASLADOS_SITUACION_ACTUAL";
export const GET_TRASLADOS_SITUACION_PERIODO = "GET_TRASLADOS_SITUACION_PERIODO";
export const GET_TRASLADOS_PENDIENTES = "GET_TRASLADOS_PENDIENTES";
export const BUSCAR_TRASLADOS = "BUSCAR_TRASLADOS";
export const AUTORIZAR_TRAMO = "AUTORIZAR_TRAMO";
export const CANCELAR_TRAMO = "CANCELAR_TRAMO";
export const RECHAZAR_TRAMO_GS = "RECHAZAR_TRAMO_GS";
export const RESOLVER_NEGATIVO_TRAMO = "RESOLVER_NEGATIVO_TRAMO";
export const GET_MOTIVOS_ANULACION_TRASLADO = "GET_MOTIVOS_ANULACION_TRASLADO";
export const GET_TRASLADOS_SEARCH_MODEL = "GET_TRASLADOS_SEARCH_MODEL";
export const RECHAZAR_TRAMO = "RECHAZAR_TRAMO";
export const AGREGAR_OBSERVACION_PT = "AGREGAR_OBSERVACION_PT";
export const MARCAR_NEGATIVO_PT = "MARCAR_NEGATIVO_PT";
export const GET_OBSERVACIONES_PT = "GET_OBSERVACIONES_PT";
export const RECHAZAR_TRAMO_PT = "RECHAZAR_TRAMO_PT";
export const GET_MOTIVOS_RECHAZO_PT = "GET_MOTIVOS_RECHAZO_PT";
export const GET_MOTIVOS_NEGATIVO_PT = "GET_MOTIVOS_NEGATIVO_PT";
export const EXPORTAR_TRASLADOS_PT = "EXPORTAR_TRASLADOS_PT";
export const AUTORIZAR_TRAMOS_BLOQUE = "AUTORIZAR_TRAMOS_BLOQUE";
export const CANCELAR_TRAMOS_BLOQUE = "CANCELAR_TRAMOS_BLOQUE";
export const CANCELAR_TRASLADO_COMPLETO = "CANCELAR_TRASLADO_COMPLETO";
export const CARGAR_NEGATIVO_DIRECTO_AT = "CARGAR_NEGATIVO_DIRECTO_AT";
export const FETCH_AGENCIAS = "FETCH_AGENCIAS";
export const CREATE_AGENCIA = "CREATE_AGENCIA";
export const UPDATE_AGENCIA = "UPDATE_AGENCIA";
export const TOGGLE_AGENCIA_STATUS = "TOGGLE_AGENCIA_STATUS";

export const getTrasladosHistorial = (idArt, siniestro) => (dispatch) =>
  dispatch({
    type: GET_TRASLADOS_HISTORIAL,
    payload: axios
      .get(`traslado/siniestro/${siniestro}?idArt=${idArt}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getTrasladosReferentes = (idArt) => (dispatch) =>
  dispatch({
    type: GET_TRASLADOS_REFERENTES,
    payload: axios
      .get(`authorization/referentes?idArt=${idArt}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getTrasladosSituacionActual = (idArt) => (dispatch) =>
  dispatch({
    type: GET_TRASLADOS_SITUACION_ACTUAL,
    payload: axios
      .get(`traslado/reportes/situacionActual?idArt=${idArt}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
const appendIdArtQuery = (url, idArt) => {
  const parsed = Number(idArt);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}idArt=${parsed}`;
};

export const getTrasladosPendientes = (idArt) => (dispatch) => {
  const query = idArt ? `?idArt=${idArt}` : "";
  return dispatch({
    type: GET_TRASLADOS_PENDIENTES,
    payload: axios
      .get(`traslado/pendientes${query}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const buscarTraslados = (filters) => (dispatch) => {
  return dispatch({
    type: BUSCAR_TRASLADOS,
    payload: axios
      .post(`traslado/tramos/buscar`, filters)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

const buildPTQueryParams = (filters = {}) => {
  const queryParams = new URLSearchParams();
  if (filters.nroSiniestro) queryParams.append("Siniestro", filters.nroSiniestro);
  if (filters.documentoTrabajador) queryParams.append("DocumentoTrabajador", filters.documentoTrabajador);
  if (filters.trabajador) queryParams.append("Trabajador", filters.trabajador);
  if (filters.estadoTramoId) queryParams.append("Estado", filters.estadoTramoId);
  if (filters.fechaDesde) queryParams.append("FechaDesde", filters.fechaDesde);
  if (filters.fechaHasta) queryParams.append("FechaHasta", filters.fechaHasta);
  if (filters.provinciaOrigen) queryParams.append("ProvinciaOrigen", filters.provinciaOrigen);
  if (filters.localidadOrigen) queryParams.append("LocalidadOrigen", filters.localidadOrigen);
  if (filters.provinciaDestino) queryParams.append("ProvinciaDestino", filters.provinciaDestino);
  if (filters.localidadDestino) queryParams.append("LocalidadDestino", filters.localidadDestino);
  if (filters.nroTramoUnico) queryParams.append("NroTramo", filters.nroTramoUnico);
  if (filters.esRetorno !== undefined && filters.esRetorno !== null) queryParams.append("Sentido", filters.esRetorno);
  return queryParams;
};

export const buscarTrasladosPT = (filters = {}) => (dispatch) => {
  const queryParams = buildPTQueryParams(filters);
  return dispatch({
    type: BUSCAR_TRASLADOS,
    payload: axios
      .get(`traslado/tramos/buscarPT?${queryParams.toString()}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const exportarTrasladosPT = (filters = {}) => (dispatch) => {
  const queryParams = buildPTQueryParams(filters);
  return dispatch({
    type: EXPORTAR_TRASLADOS_PT,
    payload: axios
      .get(`traslado/tramos/exportarPT?${queryParams.toString()}`, {
        responseType: "blob",
      })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getTrasladosSearchModel = () => (dispatch) => {
  return dispatch({
    type: GET_TRASLADOS_SEARCH_MODEL,
    payload: axios
      .get(`traslado/searchModel`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const autorizarTraslado = (idTramo, idAgencia = null, esGS = false, idArt = null, idMotivoTraslado = null) => (dispatch) =>
  dispatch({
    type: AUTORIZAR_TRAMO,
    payload: axios
      .put(
        appendIdArtQuery(
          `traslado/tramos/${idTramo}/autorizar${esGS ? "?esGS=true" : ""}`,
          idArt,
        ),
        { idAgencia, idMotivoTraslado },
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getTrasladosSituacionPorPeriodo = (fechaDesde, fechaHasta, idArt) => (dispatch) =>
  dispatch({
    type: GET_TRASLADOS_SITUACION_PERIODO,
    payload: axios
      .get(
        `traslado/reportes/porPeriodo?fechaDesde=${moment(fechaDesde).format("YYYY-MM-DD")}&fechaHasta=${moment(fechaHasta).format("YYYY-MM-DD")}&idArt=${idArt}`,
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const autorizarTramosBloque = (idTramos, idAgencia = null, esGS = false, idArt = null) => (dispatch) =>
  dispatch({
    type: AUTORIZAR_TRAMOS_BLOQUE,
    payload: axios
      .put(
        appendIdArtQuery(
          `traslado/tramos/autorizar-bloque${esGS ? "?esGS=true" : ""}`,
          idArt,
        ),
        { idTramos, idAgencia },
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const cancelarTramo = (idTramo, idMotivo, observaciones, idArt = null) => (dispatch) =>
  dispatch({
    type: CANCELAR_TRAMO,
    payload: axios
      .put(appendIdArtQuery(`traslado/tramos/${idTramo}/cancelar`, idArt), { idMotivo, observaciones })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const cancelarTramosBloque = (idTramos, idMotivo, observaciones, idArt = null) => (dispatch) =>
  dispatch({
    type: CANCELAR_TRAMOS_BLOQUE,
    payload: axios
      .put(appendIdArtQuery(`traslado/tramos/cancelar-bloque`, idArt), { idTramos, idMotivo, observaciones })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const cancelarTrasladoCompleto = (idTraslado, idMotivo, observaciones, idArt = null) => (dispatch) =>
  dispatch({
    type: CANCELAR_TRASLADO_COMPLETO,
    payload: axios
      .put(appendIdArtQuery(`traslado/traslados/${idTraslado}/cancelar`, idArt), { idMotivo, observaciones })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const rechazarTramo = (idTramo, idMotivo, observaciones, idArt = null) => (dispatch) =>
  dispatch({
    type: RECHAZAR_TRAMO,
    payload: axios
      .put(appendIdArtQuery(`traslado/tramos/${idTramo}/rechazar`, idArt), {
        idMotivo,
        observaciones,
      })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const agregarObservacionPT = (idTramo, observaciones) => (dispatch) =>
  dispatch({
    type: AGREGAR_OBSERVACION_PT,
    payload: axios
      .put(`traslado/tramos/${idTramo}/observaciones`, { observaciones })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const marcarPosibleNegativoPT = (idTramo, horaLlegada, idMotivo, observaciones, imagenes) => (dispatch) =>
  dispatch({
    type: MARCAR_NEGATIVO_PT,
    payload: axios
      .put(`traslado/tramos/${idTramo}/marcar-negativo`, { horaLlegada, idMotivo, observaciones, imagenes })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const cargarNegativoDirectoAT = (idTramo, horaLlegada, idMotivo, observaciones, imagenes) => (dispatch) =>
  dispatch({
    type: CARGAR_NEGATIVO_DIRECTO_AT,
    payload: axios
      .put(`traslado/tramos/${idTramo}/negativo-directo`, { horaLlegada, idMotivo, observaciones, imagenes })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const resolverNegativoTramo = (idTramo, idArt, resolucion) => (dispatch) =>
  dispatch({
    type: RESOLVER_NEGATIVO_TRAMO,
    payload: axios
      .put(`traslado/tramos/${idTramo}/resolver-negativo?idArt=${idArt}`, { resolucion })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getMotivosAnulacionTraslado = (idArt = null) => (dispatch) =>
  dispatch({
    type: GET_MOTIVOS_ANULACION_TRASLADO,
    payload: axios
      .get(appendIdArtQuery(`traslado/motivos-anulacion`, idArt))
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getMotivosRechazoPT = () => (dispatch) =>
  dispatch({
    type: GET_MOTIVOS_RECHAZO_PT,
    payload: axios
      .get(`traslado/motivos-rechazo-pt`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getMotivosNegativoPT = () => (dispatch) =>
  dispatch({
    type: GET_MOTIVOS_NEGATIVO_PT,
    payload: axios
      .get(`traslado/motivosNegativo`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const rechazarTramoPT = (idTramo, idMotivo, observaciones) => (dispatch) =>
  dispatch({
    type: RECHAZAR_TRAMO_PT,
    payload: axios
      .put(`traslado/tramos/${idTramo}/rechazar-pt`, { idMotivo, observaciones })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getObservacionesPT = (idTramo, idArt = null) => (dispatch) =>
  dispatch({
    type: GET_OBSERVACIONES_PT,
    payload: axios
      .get(appendIdArtQuery(`traslado/tramos/${idTramo}/observaciones`, idArt))
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

// --- ABM Agencias de Traslado (MLP-1834) ---

export const fetchAgencias = (estado = "activas", razonSocial = "") => (dispatch) =>
  dispatch({
    type: FETCH_AGENCIAS,
    payload: axios
      .get(`traslado/agencias?estado=${estado}&razonSocial=${razonSocial}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const createAgencia = (dto) => (dispatch) =>
  dispatch({
    type: CREATE_AGENCIA,
    payload: axios
      .post(`traslado/agencias`, dto)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const updateAgencia = (idAgencia, dto) => (dispatch) =>
  dispatch({
    type: UPDATE_AGENCIA,
    payload: axios
      .put(`traslado/agencias/${idAgencia}`, dto)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const toggleAgenciaStatus = (idAgencia, activo, confirmada = false) => (dispatch) =>
  dispatch({
    type: TOGGLE_AGENCIA_STATUS,
    payload: axios
      .put(`traslado/agencias/${idAgencia}/estado`, { activo, confirmada })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const fetchPrestadoresTraslado = () => () =>
  axios
    .get("traslado/prestadoresTraslado")
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

export const fetchImagenesNegativo = (idTramo) => () =>
  axios
    .get(`traslado/tramos/${idTramo}/imagenes-negativo`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
